exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "table.check-lately-organization.table > tbody > tr > td,\ntable.check-lately-organization.table > thead > tr > th {\n  padding: 8px 16px !important;\n}\n", ""]);

